import { render, staticRenderFns } from "./IngredientMaterial.vue?vue&type=template&id=22e3606a&"
import script from "./IngredientMaterial.vue?vue&type=script&lang=js&"
export * from "./IngredientMaterial.vue?vue&type=script&lang=js&"
import style0 from "./IngredientMaterial.vue?vue&type=style&index=0&id=22e3606a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports